const DEFAULT_CRM_REGISTER_URL = 'https://app.inmueble.red/register';
const DEFAULT_CRM_LOGIN_URL = 'https://app.inmueble.red/login';

function isStagingEnvironment(): boolean {
  return import.meta.env.VITE_ENVIRONMENT === 'staging';
}

function normalizeAbsoluteUrl(value: string, label: string): string {
  const trimmed = value.trim();
  if (!trimmed) {
    throw new Error(`${label} is required`);
  }

  let url: URL;
  try {
    url = new URL(trimmed);
  } catch {
    throw new Error(`${label} must be an absolute URL`);
  }

  if (url.protocol !== 'https:') {
    throw new Error(`${label} must use HTTPS`);
  }

  return url.toString();
}

export function resolveCrmLoginUrl(value?: string): string {
  const trimmed = value?.trim();
  if (trimmed && trimmed.length > 0) {
    return normalizeAbsoluteUrl(trimmed, 'VITE_CRM_LOGIN_URL');
  }

  if (isStagingEnvironment()) {
    throw new Error('VITE_CRM_LOGIN_URL is required for staging frontpage builds');
  }

  return DEFAULT_CRM_LOGIN_URL;
}

export function resolveCrmRegisterUrl(
  value?: string,
  loginUrl?: string
): string {
  const trimmed = value?.trim();
  if (trimmed && trimmed.length > 0) {
    return normalizeAbsoluteUrl(trimmed, 'VITE_CRM_REGISTER_URL');
  }

  const trimmedLoginUrl = loginUrl?.trim();
  if (trimmedLoginUrl && trimmedLoginUrl.length > 0) {
    const parsedLoginUrl = new URL(
      normalizeAbsoluteUrl(trimmedLoginUrl, 'VITE_CRM_LOGIN_URL')
    );
    parsedLoginUrl.pathname = '/register';
    parsedLoginUrl.search = '';
    parsedLoginUrl.hash = '';
    return parsedLoginUrl.toString();
  }

  if (isStagingEnvironment()) {
    throw new Error('VITE_CRM_LOGIN_URL is required for staging frontpage builds');
  }

  return DEFAULT_CRM_REGISTER_URL;
}
